<template>
  <v-card class="my-6 elevation-3 break-info">
    <v-layout class="pr-6">
    <h3 class="px-4 py-6">Break Info</h3>
    <v-spacer></v-spacer>
    <v-btn class="mt-4" dark color="success" @click="addBreakModal"> 
        <v-icon left>local_cafe</v-icon> Add Break</v-btn>
    </v-layout>
    <v-progress-linear :indeterminate="loading" class="mb-0 mt-0" :class="{ 'no-opacity': !loading }" style="height: 2px;"></v-progress-linear>
    <div>
    <v-divider></v-divider>
    <v-tabs
        v-if="breaks.length > 0"
        v-model="active"
        slider-color="primary"
        show-arrows
    >
        <v-tab 
        v-for="(item, index) in breaks"
        :key="index"
        ripple 
        >
        <template v-if="breaks.length < 2">Break</template>
        <template v-else>Break #{{ index + 1 }}</template>
        </v-tab>
        <v-tab-item
        v-for="(item, index) in breaks"
        :key="index"
        >
          <break 
            :single_break="{item, index}" 
            @edit="editBreakModal($event)"
            @delete="deleteBreakModal($event)"
          ></break>
        </v-tab-item>
    </v-tabs>
    <v-layout v-else xs12 pa-4>
        <v-flex class="text-center caption xs12">No break data</v-flex>
    </v-layout>

    <v-dialog v-if="addBreakDialog" v-model="addBreakDialog" max-width="500px" persistent>
        <v-card class="pa-4">
            <div>
                <v-card-title>
                    <h2 class="title">
                        Add Break
                    </h2>
                </v-card-title>

                <div class="py-4 px-6">
                    <v-text-field
                        class="mb-2"
                        label="Odometer Break Start*"
                        v-model="addBreakData.start_odometer"
                        placeholder="Please Enter"
                        v-mask="'####'"
                        :error-messages="errors($v.addBreakData.start_odometer) || server_errors.start_odometer"
                        @blur="$v.addBreakData.start_odometer.$touch()"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="Odometer Break End*"
                        v-model="addBreakData.end_odometer"
                        placeholder="Please Enter"
                        v-mask="'####'"
                        :error-messages="errors($v.addBreakData.end_odometer) || server_errors.end_odometer"
                        @blur="$v.addBreakData.end_odometer.$touch()"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-menu
                        ref="menu1"
                        :close-on-content-click="false"
                        v-model="menu1"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="scale-icon mb-2"
                                v-on="on"
                                v-model="addBreakData.start_time"
                                label="Start Break Time*"
                                prepend-icon="access_time"
                                readonly
                                placeholder="Please Enter"
                                :error-messages="errors($v.addBreakData.start_time) || server_errors.start_time"
                                @blur="$v.addBreakData.start_time.$touch()"
                                @focus="resetServerValidation"
                            ></v-text-field>
                        </template>
                        <v-time-picker 
                            v-if="menu1" 
                            v-model="addBreakData.start_time" 
                            format="24hr"
                            @change="$v.addBreakData.start_time.$touch(); menu1 = false"
                        ></v-time-picker>
                    </v-menu>
                    <v-menu
                        ref="menu2"
                        :close-on-content-click="false"
                        v-model="menu2"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="scale-icon mb-2"
                                v-on="on"
                                v-model="addBreakData.end_time"
                                label="End Break Time*"
                                prepend-icon="access_time"
                                readonly
                                placeholder="Please Enter"
                                :error-messages="errors($v.addBreakData.end_time) || server_errors.end_time"
                                @blur="$v.addBreakData.end_time.$touch()"
                                @focus="resetServerValidation"
                            ></v-text-field>
                        </template>
                        <v-time-picker 
                            v-if="menu2" 
                            v-model="addBreakData.end_time" 
                            format="24hr"
                            @change="$v.addBreakData.end_time.$touch(); menu2 = false"
                        ></v-time-picker>
                    </v-menu>
                    <v-text-field
                        class="mb-2"
                        label="Start Break Notes"
                        v-model="addBreakData.start_note"
                        placeholder="Please Enter"
                        prepend-icon="message"
                        :error-messages="server_errors.start_note"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="End Break Notes"
                        v-model="addBreakData.end_note"
                        placeholder="Please Enter"
                        prepend-icon="message"
                        :error-messages="server_errors.end_note"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-alert class="pa-2 mt-4" :value="$v.addBreakData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">Please fill out form correctly</span>
                    </v-alert>
                    <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">{{ serverValidationMessage }}</span>
                    </v-alert>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeAddBreak">Cancel</v-btn>
                    <v-btn color="primary" :loading="addBreakLoading" :disabled="addBreakLoading" @click="addBreak">Save</v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>

    <v-dialog v-if="editBreakDialog" v-model="editBreakDialog" max-width="500px" persistent>
        <v-card class="pa-4">
            <div>
                <v-card-title>
                    <h2 class="title">
                        <template v-if="breaks.length < 2">Edit Break Info</template>
                        <template v-else>{{`Edit Break #${editingIndex + 1} Info`}}</template>
                    </h2>
                </v-card-title>

                <div class="py-4 px-6">
                    <v-text-field
                        class="mb-2"
                        label="Odometer Break Start*"
                        v-model="editBreakData.start_odometer"
                        placeholder="Please Enter"
                        v-mask="'####'"
                        :error-messages="errors($v.editBreakData.start_odometer) || server_errors.start_odometer"
                        @blur="$v.editBreakData.start_odometer.$touch()"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="Odometer Break End*"
                        v-model="editBreakData.end_odometer"
                        placeholder="Please Enter"
                        v-mask="'####'"
                        :error-messages="errors($v.editBreakData.end_odometer) || server_errors.end_odometer"
                        @blur="$v.editBreakData.end_odometer.$touch()"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-menu
                        ref="menu1"
                        :close-on-content-click="false"
                        v-model="menu1"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="scale-icon mb-2"
                                v-on="on"
                                v-model="editBreakData.start_time"
                                label="Start Break Time*"
                                prepend-icon="access_time"
                                readonly
                                placeholder="Please Enter"
                                :error-messages="errors($v.editBreakData.start_time) || server_errors.start_time"
                                @blur="$v.editBreakData.start_time.$touch()"
                                @focus="resetServerValidation"
                            ></v-text-field>
                        </template>
                        <v-time-picker 
                            v-if="menu1" 
                            v-model="editBreakData.start_time" 
                            format="24hr"
                            @change="$v.editBreakData.start_time.$touch(); menu1 = false"
                        ></v-time-picker>
                    </v-menu>
                    <v-menu
                        ref="menu2"
                        :close-on-content-click="false"
                        v-model="menu2"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="scale-icon mb-2"
                                v-on="on"
                                v-model="editBreakData.end_time"
                                label="End Break Time*"
                                prepend-icon="access_time"
                                readonly
                                placeholder="Please Enter"
                                :error-messages="errors($v.editBreakData.end_time) || server_errors.end_time"
                                @blur="$v.editBreakData.end_time.$touch()"
                                @focus="resetServerValidation"
                            ></v-text-field>
                        </template>
                        <v-time-picker 
                            v-if="menu2" 
                            v-model="editBreakData.end_time" 
                            format="24hr"
                            @change="$v.editBreakData.end_time.$touch(); menu2 = false"
                        ></v-time-picker>
                    </v-menu>
                    <v-text-field
                        class="mb-2"
                        label="Start Break Notes"
                        v-model="editBreakData.start_note"
                        placeholder="Please Enter"
                        prepend-icon="message"
                        :error-messages="server_errors.start_note"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="End Break Notes"
                        v-model="editBreakData.end_note"
                        placeholder="Please Enter"
                        prepend-icon="message"
                        :error-messages="server_errors.end_note"
                        @focus="resetServerValidation"
                    ></v-text-field>
                    <v-alert class="pa-2 mt-4" :value="$v.editBreakData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">Please fill out form correctly</span>
                    </v-alert>
                    <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">{{ serverValidationMessage }}</span>
                    </v-alert>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeEditBreak">Cancel</v-btn>
                    <v-btn color="primary" :loading="saveEditBreakLoading" :disabled="saveEditBreakLoading" @click="editBreak">Save</v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>

    <v-dialog v-if="deleteBreakDialog" v-model="deleteBreakDialog" max-width="500px" persistent>
        <v-card class="pa-4">
          <v-card-title class="px-4">
              <h2 class="title">
                  <template v-if="breaks.length < 2">Delete Break</template>
                  <template v-else>{{`Delete Break #${deletingIndex + 1}`}}</template>
              </h2>
          </v-card-title>

          <div class="pa-4">
              Are you sure you want to delete break?
              <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                  <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
          </div>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeDeleteBreak">Cancel</v-btn>
              <v-btn color="primary" :loading="deleteBreakLoading" :disabled="deleteBreakLoading" @click="deleteBreak">Delete Anyway</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
  </v-card>
</template>

<script>
import ApiService from "@/common/api.service"
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import { valMessages, getValMessage } from '@/common/error-messages'
import { mask } from 'vue-the-mask'
import moment from 'moment'
import Break from './Break'
import { mapActions } from "vuex";

let validations = {}

export default {
    name: 'BreakInfo',
    components: {
        Break
    },
    props: [
        'breaks',
        'loading',
        'shift'
    ],
    mixins: [validationMixin],
    validations() {
        validations = {
            addBreakData: {
                start_odometer: { required, odometer: v => !helpers.req(v) || /^\d{4}$/.test(v) },
                end_odometer: { required, odometer: v => !helpers.req(v) || /^\d{4}$/.test(v) },
                start_time: { 
                    required,
                    afterShiftStart: value => 
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].start_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(this.shift[0].start_time)),
                    beforeShiftEnd: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].end_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(this.shift[0].end_time)),
                    beforeBreakEnd: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.addBreakData.end_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(`${this.shift[0].shift_date} ${this.addBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true)),
                    breakOverlap: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.breaks) ||
                        !Array.isArray(this.breaks) ||
                        this.breaks.length === 0 ||
                        !this.breaks.some(i => 
                            !this.no_data.includes(i.start_time) && 
                            !this.no_data.includes(i.end_time) &&
                            moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true)
                            .isBetween(moment(i.start_time), moment(i.end_time))
                        )
                },
                end_time: { 
                    required,
                    afterShiftStart: value => 
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].start_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(this.shift[0].start_time)),
                    beforeShiftEnd: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].end_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(this.shift[0].end_time)),
                    afterBreakStart: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.addBreakData.start_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(`${this.shift[0].shift_date} ${this.addBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true)),
                    breakOverlap: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.breaks) ||
                        !Array.isArray(this.breaks) ||
                        this.breaks.length === 0 ||
                        !this.breaks.some(i => 
                            !this.no_data.includes(i.start_time) && 
                            !this.no_data.includes(i.end_time) &&
                            moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true)
                            .isBetween(moment(i.start_time), moment(i.end_time))
                        )
                }
            },
            editBreakData: {
                start_odometer: { required, odometer: v => !helpers.req(v) || /^\d{4}$/.test(v) },
                end_odometer: { required, odometer: v => !helpers.req(v) || /^\d{4}$/.test(v) },
                start_time: { 
                    required, 
                    afterShiftStart: value => 
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].start_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(this.shift[0].start_time)),
                    beforeShiftEnd: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].end_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(this.shift[0].end_time)),
                    beforeBreakEnd: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.editBreakData.end_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(`${this.shift[0].shift_date} ${this.editBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true)),
                    breakOverlap: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.breaks) ||
                        !Array.isArray(this.breaks) ||
                        this.breaks.length === 0 ||
                        !this.breaks.some(i => 
                            this.editBreakData.shift_break_id !== i.id &&
                            !this.no_data.includes(i.start_time) && 
                            !this.no_data.includes(i.end_time) &&
                            moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true)
                            .isBetween(moment(i.start_time), moment(i.end_time))
                        )    
                },
                end_time: { required, 
                    afterShiftStart: value => 
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].start_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(this.shift[0].start_time)),
                    beforeShiftEnd: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.shift[0]) ||
                        this.no_data.includes(this.shift[0].end_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrBefore(moment(this.shift[0].end_time)),
                    afterBreakStart: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.editBreakData.start_time) ||
                        moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true).isSameOrAfter(moment(`${this.shift[0].shift_date} ${this.editBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true)),
                    breakOverlap: value =>
                        !helpers.req(value) ||
                        this.no_data.includes(this.breaks) ||
                        !Array.isArray(this.breaks) ||
                        this.breaks.length === 0 ||
                        !this.breaks.some(i => 
                            this.editBreakData.shift_break_id !== i.id &&
                            !this.no_data.includes(i.start_time) && 
                            !this.no_data.includes(i.end_time) &&
                            moment(`${this.shift[0].shift_date} ${value}`, 'YYYY-MM-DD HH:mm', true)
                            .isBetween(moment(i.start_time), moment(i.end_time))
                        )
                }
            }
        }
        this.errors = getValMessage(valMessages)(validations);
        return validations;
    },
    directives: {mask},
    data() {
        return {
            no_data: [null, '', undefined, 'null'],
            menu1: false,
            menu2: false,
            headers: [
                { text: 'Results', value: 'results', sortable: false },
                { text: 'Results', value: 'results', sortable: false },
                { text: 'Results', value: 'results', sortable: false },
                { text: 'Results', value: 'results', sortable: false }
            ],
            active: null,

            required: v => !!v || 'This field is required',
            vehicleRule: v => (v === 0 || v === 1) || 'Vehicle field is required',
            odomether: v => (/^\d{4}$/.test(v) || v === undefined || String(v) === '') || 'Please enter last 4 digits',

            addBreakDialog: false,
            addBreakFormValidation: true,
            addBreakLoading: false,
            addBreakData: {},
            
            editingIndex: null,
            editBreakDialog: false,
            breakFormValidation: true,
            saveEditBreakLoading: false,
            editBreakData: {},

            deletingIndex: null,
            deleteBreakDialog: false,
            deleteBreakLoading: false,
            deleteBreakData: {},
            serverValidation: true,
            serverValidationMessage: 'Oops something went wrong...',
            server_errors: {}
        }
    },
    methods: {
        ...mapActions(['vEmit']),
        addBreakModal() {
            this.resetServerValidation()
            this.$v.addBreakData.$reset()
            this.addBreakData = {
                shift_id: this.$route.params.id,
                staff_user_id: this.shift[0].user_id,
                staff_employee_id: this.shift[0].employee_id
            }
            this.addBreakDialog = true;
            this.addBreakLoading = false
        },
        addBreak() {
            this.resetServerValidation()
            this.$v.addBreakData.$touch()

            if (!this.$v.addBreakData.$invalid && 
                !this.no_data.includes(this.breaks) && 
                Array.isArray(this.breaks) && this.breaks.length !== 0
            ) {
                if(this.breaks.some(i => moment(i.start_time).isSame(moment(`${this.shift[0].shift_date} ${this.addBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true)) && moment(i.end_time).isSame(moment(`${this.shift[0].shift_date} ${this.addBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true)))) {
                    this.serverValidation = false
                    this.serverValidationMessage = "You cannot add break with same start and end time as existing break"
                }
                if(this.breaks.some(i => 
                    moment(i.start_time)
                    .isBetween(moment(`${this.shift[0].shift_date} ${this.addBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true), moment(`${this.shift[0].shift_date} ${this.addBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true)) ||
                    moment(i.end_time)
                    .isBetween(moment(`${this.shift[0].shift_date} ${this.addBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true), moment(`${this.shift[0].shift_date} ${this.addBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true))
                    )    
                ) {
                    this.serverValidation = false
                    this.serverValidationMessage = "Break times cannot overlap"
                }
            }

            if(!this.$v.addBreakData.$invalid && this.serverValidation){
                this.addBreakLoading = true
                let body = {...this.addBreakData}

                ApiService.put('/time_and_mileage/update_break', body)
                    .then(response => {
                        this.addBreakLoading = false
                        this.vEmit({ 
                            name: "notification", 
                            data: {
                                status: 'success', 
                                text: 'Break has been successfully added.'
                            }    
                        });
                        this.$emit('reload');
                        this.closeAddBreak();
                    })
                    .catch(({ response }) => {
                        this.addBreakLoading = false
                        this.serverValidation = false
                        if (response.data.error) {
                            this.serverValidationMessage = this.titleCase(response.data.error)
                        }
                        if(response.data.message){
                            this.serverValidationMessage = response.data.message
                        }
                        if (response.data.errors) {
                            if (typeof response.data.errors === 'string') {
                                this.serverValidationMessage = response.data.errors
                            } else {
                                this.server_errors = response.data.errors
                            }
                        }
                    })
            }
        },
        closeAddBreak() {
            this.addBreakDialog = false;
        },

        editBreakModal(i) {
            this.resetServerValidation()
            this.$v.editBreakData.$reset()
            this.editBreakData = {
                shift_id: this.$route.params.id,
                shift_break_id: this.breaks[i].id,
                start_time: this.breaks[i].start_time ? this.onlyTime(this.breaks[i].start_time) : null,
                end_time: this.breaks[i].end_time ? this.onlyTime(this.breaks[i].end_time) : null,
                start_odometer: this.breaks[i].start_odometer,
                end_odometer: this.breaks[i].end_odometer,
                start_note: this.breaks[i].start_note,
                end_note: this.breaks[i].end_note,
                staff_user_id: this.shift[0].user_id,
                staff_employee_id: this.shift[0].employee_id
            }
            this.editingIndex = i
            this.editBreakDialog = true;
            this.saveEditBreakLoading = false
        },
        editBreak() {
            this.resetServerValidation()
            this.$v.editBreakData.$touch()

            if (!this.$v.editBreakData.$invalid && 
                !this.no_data.includes(this.breaks) && 
                Array.isArray(this.breaks) && this.breaks.length !== 0
            ) {
                if(this.breaks.some(i => i.id !== this.editBreakData.shift_break_id && moment(i.start_time).isSame(moment(`${this.shift[0].shift_date} ${this.editBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true)) && moment(i.end_time).isSame(moment(`${this.shift[0].shift_date} ${this.editBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true)))) {
                    this.serverValidation = false
                    this.serverValidationMessage = "Break cannot have same start and end time as other existing break"
                }
                if(this.breaks.some(i => 
                    i.id !== this.editBreakData.shift_break_id && 
                        (
                            moment(i.start_time)
                            .isBetween(moment(`${this.shift[0].shift_date} ${this.editBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true), moment(`${this.shift[0].shift_date} ${this.editBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true)) ||
                            moment(i.end_time)
                            .isBetween(moment(`${this.shift[0].shift_date} ${this.editBreakData.start_time}`, 'YYYY-MM-DD HH:mm', true), moment(`${this.shift[0].shift_date} ${this.editBreakData.end_time}`, 'YYYY-MM-DD HH:mm', true))
                        )
                    )    
                ) {
                    this.serverValidation = false
                    this.serverValidationMessage = "Break times cannot overlap"
                }
            }

            if(!this.$v.editBreakData.$invalid && this.serverValidation){
                this.saveEditBreakLoading = true
                let body = {...this.editBreakData}

                ApiService.put('/time_and_mileage/update_break', body)
                    .then(response => {
                        this.saveEditBreakLoading = false
                        this.vEmit({ 
                            name: "notification", 
                            data: {
                                status: 'success',
                                text: 'Break Info has been successfully edited.'
                            }
                        });
                        this.$emit('reload');
                        this.closeEditBreak();
                    })
                    .catch(({ response }) => {
                        this.saveEditBreakLoading = false
                        this.serverValidation = false
                        if (response.data.error) {
                            this.serverValidationMessage = this.titleCase(response.data.error)
                        }
                        if(response.data.message){
                            this.serverValidationMessage = response.data.message
                        }
                        if (response.data.errors) {
                            if (typeof response.data.errors === 'string') {
                                this.serverValidationMessage = response.data.errors
                            } else {
                                this.server_errors = response.data.errors
                            }
                        }
                    })
            }
        },
        closeEditBreak() {
            this.editBreakDialog = false;
        },


        deleteBreakModal(i) {
            this.serverValidation = true
            this.deletingIndex = i
            this.deleteBreakDialog = true;
            this.deleteBreakLoading = false
        },
        deleteBreak() {
            this.deleteBreakLoading = true

            ApiService.delete(`/time_and_mileage/delete_break/${this.breaks[this.deletingIndex].id}`)
                .then(response => {
                    this.deleteBreakLoading = false
                    this.vEmit({ 
                        name: "notification",
                        data: {
                            status: 'success', 'text': 'Break has been successfully deleted.'
                        }
                    });
                    this.$emit('reload');
                    this.closeDeleteBreak();
                })
                .catch(({ response }) => {
                    this.deleteBreakLoading = false
                    this.serverValidation = false
                    if(response.data.error){
                        this.serverValidationMessage = _.upperFirst(response.data.error.replace(/_/g, ' '))
                    }
                })
        },
        closeDeleteBreak() {
            this.deleteBreakDialog = false;
        },


        onlyDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        onlyTime(date) {
            return moment(date).format('HH:mm');
        },
        onlyNumbers ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault()
            }
        },
        titleCase(str){
            return _.startCase(str.replace(/_/g, ' '));
        },
        resetServerValidation() {
            this.serverValidation = true
            this.serverValidationMessage = 'Oops something went wrong...'
            this.server_errors = {}
        },
        errors: getValMessage(valMessages)(validations)
    }
    }
</script>
